import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch"

const deleteInvoice = (
    token: string,
    backend: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}invoices/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteInvoice;
